import { takeUntil } from 'rxjs';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, Subject } from 'rxjs';
import { ConfigService } from "../../Services/ConfigService";
import { TypeCountryService } from '../../Services/Custom/ServiceTypeCountry';


@Component({
	selector: 'AddressEdit',
	templateUrl: 'AddressEdit.html',
	
})
export class AddressEditComponent implements OnInit, AfterViewInit, OnDestroy {

	protected obsToCloseSubject = new Subject();
	ngOnDestroy(){
		this.obsToCloseSubject.next(null);
		this.obsToCloseSubject.complete();
	}
	ngOnInit(): void {
		this.myTypeCountryService.loadAll(true)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(data => {
				this.countries = data;
				this.changeCountry(this.myItem.Country, false);
			});
		
	}
	constructor(public configData: ConfigService,
		private myTypeCountryService: TypeCountryService,
	) {
	}

	@Output() zipChange = new EventEmitter();

	@Input()
	htmlprefix: string = '';

	@Input()
	AddressEditForm: NgForm;

	@Input()
	showSuggestions = false;

	placeSuggestions: any[] = [];

	addressChanged() {
		this.zipChange.emit({});
	}

	fillAddress(obj: any) {
		var thisHolder = this;
		if (obj) {
			thisHolder.placeSuggestions = [];
			var service = new google.maps.Geocoder();
			service.geocode({
				placeId: obj.place_id
			}, function (results: any, status: any) {
				if (status != "OK") {
					return;
				}

				if (!thisHolder.myItem) {
					thisHolder.myItem= {} as TooBig4Car.Logic.Address;
				}
				if (results && results.length) {
					var postalCodes = results[0].address_components.filter((a: any) => a.types.indexOf('postal_code') >= 0);
					if (postalCodes.length) {
						thisHolder.myItem.ZipCode = postalCodes[0].long_name;
					}

					var cities = results[0].address_components.filter((a: any) => a.types.indexOf('locality') >= 0);
					if (cities.length) {
						thisHolder.myItem.City = cities[0].long_name;
					}
					var states = results[0].address_components.filter((a: any) => a.types.indexOf('administrative_area_level_1') >= 0);
					if (states.length) {
						thisHolder.myItem.State = states[0].short_name;
					}
					var nums = results[0].address_components.filter((a: any) => a.types.indexOf('street_number') >= 0);
					var routes = results[0].address_components.filter((a: any) => a.types.indexOf('route') >= 0);
					if (routes.length) {
						if (nums.length) {
							thisHolder.myItem.Address1 = nums[0].long_name + ' ' + routes[0].long_name;
						}
						try {
							thisHolder.myItem.Latitude = results[0].geometry.location.lat();
							thisHolder.myItem.Longitude = results[0].geometry.location.lng();
						} catch { }
					}
					thisHolder.addressChanged();
				}
			});
		}
	}

	formatAddress(address: TooBig4Car.Logic.Address): string {
		if (!address) {
			return '';
		}
		let addressString = `${address.Address1 || ''} ${address.Address2 || ''} ${address.City || ''} ${address.State || ''} ${address.ZipCode || ''}`
		addressString = addressString.replace(/[,.;!:'"{}|`@#$%^&*()+=_?]+/g, "").trim();
		return addressString;
	}

	addressKeyUp = new Subject<KeyboardEvent>();

	ngAfterViewInit() {
		const keyUpSub = this.addressKeyUp.pipe(
			map(evnt => {
				var addr: TooBig4Car.Logic.Address = this.configData.deepClone( this.myItem);
				addr.AddressID = this.configData.DefaultEmptyGuid;
				return addr;
			}),
			debounceTime(500),
			distinctUntilChanged((c: TooBig4Car.Logic.Address, p: TooBig4Car.Logic.Address) => {
				return this.formatAddress(c) === this.formatAddress(p)
			}),
		)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(addr => {
			addr.Latitude = addr.Longitude = null;
			this.addressChanged();
			if (addr.Address1) {
				this.addressLookup(this.formatAddress(addr));

			}
		});
	}


	addressLookup(myAddress: string) {
		if (this.showSuggestions) {
			var displaySuggestions = (predictions: any, status: any) => {
				this.placeSuggestions = [];
				if (status != google.maps.places.PlacesServiceStatus.OK) {
					//alert(status);
					return;
				}
				console.log('Search Returned ' + predictions.length + ' results');
				predictions.forEach((prediction: any) => {
					this.placeSuggestions.push({
						obj: prediction,
						desc: (prediction.description || '').replace(', USA', '')
					});
				});
			};

			var service = new google.maps.places.AutocompleteService();
			service.getPlacePredictions({
				input: myAddress,
				componentRestrictions: { country: 'us' },
				types: ['address']
			}, displaySuggestions);
		}
	}
	changeCountry(countryName: string, trigger: boolean) {
		this.states = [];
		if (countryName) {
			var countries = this.countries.filter(a => a.TypeName == countryName);
			if (countries && countries.length) {
				this.states = countries[0].TypeStateCol;
			}
			if (trigger) {
				this.addressChanged();
			}
		}
	}

	states: TooBig4Car.Logic.TypeState[] = [];
	countries: TooBig4Car.Logic.TypeCountry[] = [];


	@Input()
	set address(val: TooBig4Car.Logic.Address) {
		this.myItem = val;
		this.changeCountry(this.myItem.Country, false);
	}
	get address(): TooBig4Car.Logic.Address {
		return this.myItem;
	}
	myItem = {
		Country: 'USA'
	} as TooBig4Car.Logic.Address;

} 
